import { render, staticRenderFns } from "./AssignedAuctionsPage.vue?vue&type=template&id=02180ba2"
import script from "./AssignedAuctionsPage.vue?vue&type=script&lang=js"
export * from "./AssignedAuctionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports